import makeStyles from "@material-ui/core/styles/makeStyles";
import { AppList } from "components/list/AppList";
import { ScrollingWrapper } from "components/ScrollingWrapper";
import React from "react";
import { useTranslate } from "react-admin";

import { InventoryListActions } from "../components/Actions";
import { InventoryListFilter } from "../components/Filters";
import { InventoryListGrid } from "../InventoryListGrid";

const useStyles = makeStyles({
	listRoot: {
		"& .MuiToolbar-root": {
			display: "flex",
			alignItems: "center",
			paddingBottom: "8px",
		},
		"& .MuiCard-root": {
			width: "100%",
		},
	},
});

export const sortDefaultValue = { field: "sscc", order: "DESC" };

export const InventoryList = () => {
	const translate = useTranslate();
	const classes = useStyles();

	const filterDefaultValues = {};

	return (
		<AppList
			basePath="/inventory-list"
			resource="inventory-list"
			perPage={50}
			rowsPerPageOptions={[25, 50, 100]}
			sort={sortDefaultValue}
			bulkActionButtons={false}
			exporter={false}
			className={classes.listRoot}
			title={translate("resources.inventory-list.name", { _: "Inventory List" })}
			filters={<InventoryListFilter translate={translate} />}
			actions={<InventoryListActions translate={translate} />}
			filterDefaultValues={filterDefaultValues}
		>
			<ScrollingWrapper>
				<InventoryListGrid translate={translate} />
			</ScrollingWrapper>
		</AppList>
	);
};
